export default __webpack_public_path__ + "static/media/image2.e80b3784.jpg";